import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Tooltip } from "react-tooltip";
import { getTemplateDetail, updateTemplateDetail } from "../../../../utils/backToTop";
import '../../../../assets/css/loader.css'; 

//Import Widgets
import NumberOneTemplateWidget from "../../../../components/Apps/BackToTop/Template/NumberOneTemplateWidget";
import NumberTwoTemplateWidget from "../../../../components/Apps/BackToTop/Template/NumberTwoTemplateWidget";
import NumberThreeTemplateWidget from "../../../../components/Apps/BackToTop/Template/NumberThreeTemplateWidget";
import NumberFourTemplateWidget from "../../../../components/Apps/BackToTop/Template/NumberFourTemplateWidget"; 
import NumberFiveTemplateWidget from "../../../../components/Apps/BackToTop/Template/NumberFiveTemplateWidget";
import NumberSixTemplateWidget from "../../../../components/Apps/BackToTop/Template/NumberSixTemplateWidget";

//Import Tabs
import ButtonTab from "../../../../components/Apps/BackToTop/ButtonTab";
import PositionTab from "../../../../components/Apps/BackToTop/PositionTab";
import SettingTab from "../../../../components/Apps/BackToTop/SettingTab";

export default function EditBackToTop() {
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [activeSection, setActiveSection] = useState("Button");
    const [activeTemplateSection, setActiveTemplateSection] = useState("");
    const [selectedLayout, setSelectedLayout] = useState("");
    const [selectedTemplateImage, setSelectedTemplateImage] = useState("");
    const [renameWidgetNameModel, setRenameWidgetNameModel] = useState(false);
    const [widgetName, setWidgetName] = useState("Untitled Back To Top");
    const [newWidgetName, setNewWidgetName] = useState("");
    const { uuid } = useParams();
    const [isTemplateId, setIsTemplateId] = useState(null);

    const [backToTopTabData, setBackToTopTabData] = useState({
        is_website_frontend: "",  
        text_title: "",     
        button_color: "",     
        icion_text_color: "",     
        border_color: "",     
        size_type: "small",     
        shape_type: "normal-shape",     
        position_type: "Floating",     
        position: "bottom_right",     
        position_offest: "0px",     
        scroll_position_to_display: 600,     
        setting_pages_type: "All_Pages",     
        setting_devices_type: ["Desktop","Tablets","Phones"],     
        custom_css: "",   
        custom_js: "", 
    });

    // Open Widget Name Popup
    const openRenameWidgetNamePopup = () => {
        setNewWidgetName(widgetName);
        setRenameWidgetNameModel(true);
        document.body.classList.add("popup-open");
    };

    // Close Widget Name Popup
    const closeRenameWidgetNamePopup = () => {
        setRenameWidgetNameModel(false);
        document.body.classList.remove("popup-open");
    };

    // Save Widget Name Popup
    const saveWidgetName = () => {
        if (newWidgetName.trim() !== "") {
            setWidgetName(newWidgetName); 
        }
        closeRenameWidgetNamePopup();
    };

    // Function to update values dynamically
    const updateBackToTopTabData = (key, value) => {
        setBackToTopTabData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const menuItems = [
        { key: "Button", icon: "button.png", label: "Button" },
        { key: "Position", icon: "position.png", label: "Position" },
        { key: "Settings", icon: "setting.png", label: "Settings" },
    ];

    // Fetching Tempate data
    useEffect(() => {
        const fetchData = async () => {
            try {
                const templateResult = await getTemplateDetail(uuid);

                //check if result is exist
                if (templateResult.data) {
                    setIsTemplateId(templateResult.data.uuid);
                    setWidgetName(templateResult.data.name);
                    setActiveTemplateSection(templateResult.data.template_name);
                    setSelectedLayout(templateResult.data.layout_type);
                    setSelectedTemplateImage(templateResult.data.template_image);
                    // Convert settings array to object
                    const settingsObject = templateResult.data.settings.reduce((acc, setting) => {
                        acc[setting.setting_key] = setting.setting_value;
                        return acc;
                    }, {});

                    setBackToTopTabData(settingsObject); 
                }
            } catch (error) {
                //console.error("Error fetching data:", error);
            }
        };
        
        fetchData();
    }, [uuid, setBackToTopTabData]);
  
    //Update Form data
    const updateForm = async (e) => {
        e.preventDefault();

        setIsSubmitting(true);
        try {
            const extractedImageName = selectedTemplateImage.split('/').pop();

            // Convert settings object back into an array of key-value pairs
            const settingsArray = Object.entries(backToTopTabData).map(([key, value]) => ({
                setting_key: key,
                setting_value: value,
            }));

            // Collect data from refs
            const payload = {
                template_id: isTemplateId,
                name: widgetName,
                template_name: activeTemplateSection,
                template_image: extractedImageName,
                layout_name: selectedLayout,
                layout_type: selectedLayout,
                settings: settingsArray,
            };
            
            //Api Call
            let api_response = await updateTemplateDetail(payload);

            //Check Responce
            if (api_response.status === true) {
                toast.success(api_response.message);
                // Redirect after 2 seconds
                setTimeout(() => {
                    navigate('/customer/apps/back-to-top');
                }, 2000); 
            } else {
                toast.error(api_response.message);
            }
        } catch (error) {
            toast.error('Oops Something Wrong. Please Try Again!' + error.message);
        } finally {
            setIsSubmitting(false);
        }
    };

  return (
    <>
        <div className="create-goole-reviews-all">
            <div className="overlay-side-baar">
                <div className="side-baar-inner-one">
                    <ul>
                        {menuItems.map((item) => (
                            <li key={item.key}>
                                <button
                                    className={activeSection === item.key ? "active" : ""}
                                    onClick={() => setActiveSection(item.key)}
                                >
                                    <img
                                        src={`${process.env.PUBLIC_URL}/back-to-top/icons/${item.icon}`}
                                        alt={`${item.key} icon`}
                                    />
                                    <span>{item.label}</span>
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="side-baar-inner-tow">
                    {/* Conditional Rendering for Sections */}
                    {activeSection === "Button" && (
                        <ButtonTab updateBackToTopTabData={updateBackToTopTabData} backToTopTabData={backToTopTabData} />
                    )}
                    {activeSection === "Position" && (
                        <PositionTab updateBackToTopTabData={updateBackToTopTabData} backToTopTabData={backToTopTabData} />
                    )}
                    {activeSection === "Settings" && (
                        <SettingTab updateBackToTopTabData={updateBackToTopTabData} backToTopTabData={backToTopTabData}/>
                    )}
                </div>
            </div>
            <div className="create-goole-reviews-right">
                <div className="content-wrapper count-add-class">
                    <div className="source-header-row">
                        <h2><Link to="/customer/apps/back-to-top"><i className="fa fa-angle-left" aria-hidden="true"></i> Back</Link> </h2>
                        <div className="untitled-widget-name">
                            <button onClick={openRenameWidgetNamePopup} data-tooltip-id="rename-tooltip"><img src={`${process.env.PUBLIC_URL}/back-to-top/back-to-top.svg`} alt="back-to-top"/>{ widgetName }</button>
                            <Tooltip id="rename-tooltip" place="top" content="Rename Widget" />
                        </div>
                        <div className='submit-google-review'>
                          <button type="button" onClick={updateForm} className={`form-button ${isSubmitting ? 'disabled' : ''}`} disabled={isSubmitting}>Publish</button>
                          <Link to="/customer/apps/back-to-top/pricing/single" className="view-plan">View Plans</Link>
                          <Link to="/customer/apps/back-to-top" className="close-button">Close</Link></div>
                    </div>
                    <div className="source-title-row">Announcement Bar <i className="fa fa-angle-right" aria-hidden="true"></i> <strong>Connect</strong></div>

                    {/*Check template type*/}
                    {activeTemplateSection === "1_Temp" && (
                      <NumberOneTemplateWidget backToTopTabData={backToTopTabData}/>
                    )}

                    {activeTemplateSection === "2_Temp" && (
                      <NumberTwoTemplateWidget backToTopTabData={backToTopTabData}/>
                    )}

                    {activeTemplateSection === "3_Temp" && (
                      <NumberThreeTemplateWidget backToTopTabData={backToTopTabData}/>
                    )}

                    {activeTemplateSection === "4_Temp" && (
                      <NumberFourTemplateWidget backToTopTabData={backToTopTabData}/>
                    )}

                    {activeTemplateSection === "5_Temp" && (
                      <NumberFiveTemplateWidget backToTopTabData={backToTopTabData}/>
                    )}

                    {activeTemplateSection === "6_Temp" && (
                      <NumberSixTemplateWidget backToTopTabData={backToTopTabData}/>
                    )}
                </div>
            </div>
        </div>

        {/* Rename Popup */}
        {renameWidgetNameModel && (
            <div className="fixed top-50 left-50 w-full h-full bg-opacity-50 flex justify-center items-center popup-main rounded overflow-hidden widget-rename-model">
                <div className="bg-white p-3 rounded-lg shadow-lg">
                    <h3 className="text-lg font-semibold">Rename Widget</h3>
                    <label>Widget Name</label>
                    <input
                        type="text"
                        className="border p-2 w-full mt-2"
                        value={newWidgetName}
                        onChange={(e) => setNewWidgetName(e.target.value)}
                    />
                    <div className="mt-3 flex justify-end">
                        <button className="px-3 py-1 bg-gray-200 rounded mr-2" onClick={closeRenameWidgetNamePopup}>
                            Cancel
                        </button>
                        <button type="button" className="px-3 py-1 bg-blue-500 text-white rounded" onClick={saveWidgetName}>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        )}
    </>
  );
} 